export const updateExistingTicketFromMessage = (tickets, incomingTicket) => {
  const ticketIndex = tickets.findIndex(ticket => ticket.id === incomingTicket?.id);
  if (ticketIndex === -1) return tickets;

  const nextTickets = [...tickets];
  const previousTicket = nextTickets[ticketIndex];
  const previousContact = previousTicket.contact;
  const previousUpdatedAt = Date.parse(previousTicket.updatedAt || "");
  const incomingUpdatedAt = Date.parse(incomingTicket.updatedAt || "");
  const latestUpdatedAt = Number.isFinite(incomingUpdatedAt) &&
    (!Number.isFinite(previousUpdatedAt) || incomingUpdatedAt > previousUpdatedAt)
    ? incomingTicket.updatedAt
    : previousTicket.updatedAt;

  nextTickets[ticketIndex] = {
    ...previousTicket,
    lastMessage: incomingTicket.lastMessage,
    unreadMessages: incomingTicket.unreadMessages,
    updatedAt: latestUpdatedAt,
    contact: incomingTicket.contact
      ? { ...previousContact, ...incomingTicket.contact }
      : previousContact
  };

  nextTickets.unshift(nextTickets.splice(ticketIndex, 1)[0]);
  return nextTickets;
};

// When authorization cannot expose a complete message payload for a ticket
// without an owner/queue, the backend sends only a safe kanbanRefresh notice.
// Reconcile Automations through the authorized API so the card appears or
// moves immediately instead of waiting for F5/visibilitychange.
export const shouldRefreshAutomationOnSafeRealtime = status =>
  status === "chatbot";
